<template>
    <header :class="['app-header', {fixed: isFixed && !isMobileMenu, 'fixed02': isFixed && isMobileMenu, sp: isMobileMenu}]">

        <img v-if="$route.name === 'home' && !isFixed" class="logo pc" src="./images/logo.png" alt="AUBE" style="margin: 0 auto;">
        <img v-if="$route.name !== 'home' && !isFixed" class="logo pc" src="./images/logo_04.png" alt="AUBE" style="margin: 0 auto;">
        <img v-if="isFixed" class="logo pc" src="./images/logo_01.png" alt="AUBE" style="margin: 0 auto;">
        <img class="logo sp topLayer" src="./images/logo_01.png" alt="AUBE" style="margin: 0 auto;">

        <div v-if="!isMobileMenu" class="right">
            <div>
                <ul>
                    <li>
                        <language-choice :isFixed="isFixed"></language-choice>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="typeof $route.name !== 'undefined' && $route.name !== 'home'" class="nav pc">
            <ul>
                <li v-if="$route.meta.parent">></li>
                <li v-if="$route.meta.parent"><router-link :to="{name: $route.meta.parent}">{{ $t('menu.'+$route.meta.parent) }}</router-link></li>
                <li>></li>
                <li>{{ $t('menu.'+ $route.name) }}</li>
            </ul>
        </div>

        <div class="sp">
            <div class="buttonWrapper">
                <language-choice isFixed></language-choice>
            </div>
        </div>
    </header>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import LanguageChoice from '../LanguageChoice/LanguageChoice.vue';
    import UserService from '../../services/UserService';

    export default {
        name: 'app-header',

        data() {
            return {
                isFixed: false,
                isMobileMenu: false,
                isOpenMenu: false,
                isLogged: true,
            }
        },

        components: {
            LanguageChoice
        },

        methods: {
            handleScroll() {
                this.isFixed = this.isMobileMenu || window.scrollY > 10;

        		// $('header .right .user .text').removeClass('disabled');
        		// $('header .right .user .text').addClass('disabled');
	        },

            updateResize() {
                this.isMobileMenu = window.innerWidth <= 991;

                // $('header .right .user .text').removeClass('disabled');
                // $('header .right .user .text').addClass('disabled');
            },

            async handleOnClickLogout(e) {
                try {
                    await UserService.revokeToken(AuthUtil.getAuthToken());
                } catch (e) {}
                AuthUtil.clearAuth();
                this.isOpenMenu = false;
                this.$router.go('');
            },

            handleOnClickOpenMenu() {
                this.isOpenMenu = !this.isOpenMenu;
            },

            handleOnClickCloseMenu() {
                this.isOpenMenu = false;
            }
        },

        mounted() {
            this.isLogged = AuthUtil.isAuth();
            this.isMobileMenu = window.innerWidth <= 991;

            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.updateResize);
        },

        destroy() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.updateResize);
        }
    }
</script>
